// Shared formatting helpers for the funded-book views.
export const currency = (n) =>
  n != null && n !== ''
    ? `$${Number(n).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`
    : '—';

// Dates in these collections are plain ISO day strings ("2017-04-07").
export const fmtDate = (d) => {
  if (!d) return '—';
  const date = typeof d === 'string' && /^\d{4}-\d{2}-\d{2}/.test(d)
    ? new Date(`${d.slice(0, 10)}T00:00:00`)
    : new Date(d);
  if (Number.isNaN(date.getTime())) return String(d);
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
};

export const fmtDateTime = (d) => {
  if (!d) return '—';
  const date = new Date(d);
  if (Number.isNaN(date.getTime())) return String(d);
  return date.toLocaleString('en-US', {
    month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit',
  });
};

// client_id encodes the identity key: name:/ein:/email:. Derive a readable label.
export const clientIdLabel = (clientId) => {
  if (!clientId) return '—';
  const [kind, ...rest] = clientId.split(':');
  const value = rest.join(':');
  if (kind === 'ein') return `EIN ${value}`;
  if (kind === 'email') return value;
  return value || clientId;
};
